import React, { useEffect } from "react";
import { useReportingTemplateStore } from "../../../config/stores";
import { isEmpty } from "lodash";
import ReportingTemplatesTable from "./ManageReportingTemplates.jsx/ReportingTemplatesTable";
import ViewActivityReport from "./ManageReportingTemplates.jsx/ActivityReport";

const ActivityReportingTemplates = () => {
  const reportTemplateStore = useReportingTemplateStore();

  useEffect(() => {
    if (isEmpty(reportTemplateStore.reportingTemplates)) {
      reportTemplateStore.getReportingTemplates();
    }
  }, [reportTemplateStore.reportingTemplates]);

  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold">ACTIVITY REPORT</h5>
      <ReportingTemplatesTable
        canEdit={false}
        reportingTemplates={reportTemplateStore.reportingTemplates?.data}
        refreshTable={reportTemplateStore.getReportingTemplates}
      />
      <ViewActivityReport />
    </div>
  );
};

export default ActivityReportingTemplates;
